export enum PhoneSize {
	SHORT = 'short',
	LONG = 'long',
}
export interface IPhoneCall {
	phoneNumber?: string;
	size?: PhoneSize;
	text?: string;
	className?: string;
}
